import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TransactionRoutingModule } from './transaction-routing.module';
import { ViewCompconfsComponent } from './composants/view-compconfs/view-compconfs.component';
import { InsertCompconfFileComponent } from './composants/insert-compconf-file/insert-compconf-file.component';
import { SharedModule } from '../../shared/shared.module';


@NgModule({
  declarations: [
    ViewCompconfsComponent,
    InsertCompconfFileComponent
  ],
  imports: [
    CommonModule,
    TransactionRoutingModule,
    SharedModule
  ]
})
export class TransactionModule { }
